import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../../context/AppConfig";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const AttendanceGraph = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    fetchAttendanceAnalysis();
  }, []);

  const fetchAttendanceAnalysis = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/attendance-analysis/`);
      const dates = response.data.map((item) => item.date);
      const workers = response.data.map((item) => item.total_workers);

      setChartData({
        labels: dates,
        datasets: [
          {
            label: "Total Workers Attended",
            data: workers,
            backgroundColor: "rgba(54, 162, 235, 0.6)",
            borderColor: "rgba(54, 162, 235, 1)",
            borderWidth: 1,
          },
        ],
      });
    } catch (error) {
      console.error("Error fetching attendance analysis:", error);
    }
  };

  return (
    <div className="container mt-4">
      <h3>Daily Attendance Analysis</h3>
      <Bar data={chartData} />
    </div>
  );
};

export default AttendanceGraph;
